export default {};



// WEBPACK FOOTER //
// ./src/store/modules/package/index.js